import { ERROR_CODES } from '@/consts';

export default class ClosureExits extends Error {
  static code = ERROR_CODES.CASH_LOG_CLOSURE_EXISTS;

  constructor(message) {
    super(message || 'Cash closure exists.');
    this.code = ERROR_CODES.CASH_LOG_CLOSURE_EXISTS;
  }
}
